import React, { useState } from 'react';
import { CameraOffIcon } from 'lucide-react';
import { Car } from '../types/car';
interface CarGalleryProps {
  car: Car;
  badge?: React.ReactNode;
}
type Angle = 'front' | 'side' | 'interior';
const angles: {
  key: Angle;
  label: string;
}[] = [{
  key: 'front',
  label: 'Frente'
}, {
  key: 'side',
  label: 'Lateral'
}, {
  key: 'interior',
  label: 'Interior'
}];
export function CarGallery({
  car,
  badge
}: CarGalleryProps) {
  const [angle, setAngle] = useState<Angle>('front');
  const photos = car.photos;
  const current = angles.find(a => a.key === angle) ?? angles[0];
  const src = photos[angle];
  const name = `${car.brand} ${car.model} ${car.version}`;
  return <div className="relative aspect-[3/2] overflow-hidden bg-ink" data-id="element-37" data-mp="2t47wg3cs3my4">
      {src ? <img src={src} alt={`${name} — ${current.label.toLowerCase()}`} loading="lazy" className="h-full w-full object-cover" data-id="element-38" data-mp="1mnco57qjskz2" /> : <div className="flex h-full flex-col items-center justify-center gap-2 text-muted" data-id="element-39" data-mp="1hnqaix6t52pq">
          <CameraOffIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="yp4qkhzv4hrb" />
          <span className="text-xs" data-id="element-41" data-mp="13mwel0xdzjq8">Foto {current.label.toLowerCase()} no disponible</span>
        </div>}

      {badge}

      <div role="tablist" aria-label={`Fotos de ${name}`} className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1 rounded-full border border-white/10 bg-ink/75 p-1 backdrop-blur" data-id="element-42" data-mp="pmbxc974dvyu">
        {angles.map(a => {
        const active = a.key === angle;
        return <button key={a.key} type="button" role="tab" aria-selected={active} onClick={() => setAngle(a.key)} className={`h-7 whitespace-nowrap rounded-full px-3 text-[11px] font-semibold transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon ${active ? 'bg-neon text-ink' : 'text-white/80 hover:text-white'}`} data-id="element-43" data-mp="kp28aunn7mbj">
              {a.label}
            </button>;
      })}
      </div>
    </div>;
}